export const launchpadData = [
  {
    title: "ICO Launchpad Development",
    description:
      "The Initial Coin Offering, or ICO, is a popular method of acquiring funds. We create smart contract-based ICO platforms that allow businesses to smoothly publish their tokens and projects in order to generate the necessary funding",
  },
  {
    title: "ILO Launchpad Development",
    description:
      "ILO (Initial Liquidity Offering) is a direct approach for companies to fuel their growth. Depending on the business use case, we design ILO launchpads that are strengthened with AMM (Automated Market Maker), a liquidity pool, and other market-leading capabilities.",
  },
  {
    title: "INO Launchpad Development",
    description:
      "Although it is a new entry, INO (Initial NFT Offering) is quickly gaining favour among those looking to raise funding to develop their NFTs. Our competence ranges from INO launchpad construction through the deployment of performance-optimized platforms for a positive user experience.",
  },
  {
    title: "IFO Launchpad Development",
    description:
      "IFO (Initial Farming Offering) is growing traction on DEX platforms. It intends to raise revenue through agricultural events. We create IFO launchpads with market-leading features to ensure peak performance.",
  },
  {
    title: "IIO Launchpad Development",
    description:
      "IIO, or Initial Insurance Offering, has grown in popularity among crypto aficionados. Antier's cross-functional team creates highly scalable and secure IIO launchpads for insurance industry partners.",
  },
  {
    title: "IGO Launchpad Development",
    description:
      "IGO (Initial Game Offering), like INO, is a new concept that has swiftly acquired acceptance. It entails fundraising for a blockchain-based game. We create self-explanatory IGO launchpads to assist businesses in entering the GameFi industry.",
  },
  {
    title: "IDO Launchpad Development",
    description:
      "IDO, or Initial DEX Offering, is a common approach to raise cash for decentralised initiatives. Our IDO launchpad development service is focused on producing world-class platforms that are synonymous with performance, scalability, and security.",
  },
  {
    title: "IEO Launchpad Development",
    description:
      "To begin fundraising, IEO (Initial Exchange Offering) products are listed on cryptocurrency platforms. Our blockchain engineers specialise in the creation of bespoke IEO launchpads depending on various company requirements.",
  },
];

export const featureData = [
  {
    img: require("../../../image/Launchpad/fe_img_one.webp"),
    title: "Real-Time Monitoring",
    description:
      "Our Whitelabel launchpad development company ensures that our customers can use a launchpad that lists their company for increased visibility",
  },
  {
    img: require("../../../image/Launchpad/fe_img_two.webp"),
    title: "Fundraising",
    description:
      "Our Whitelabel Launchpad may provide a plethora of brand-new funding avenues. We advocate revenue-collection models",
  },
  {
    img: require("../../../image/Launchpad/fe_img_three.webp"),
    title: "Possibilities for Investment",
    description:
      "Our white-label launchpad gives you a place to put your project ideas into action and acquire finance for your business",
  },
  {
    img: require("../../../image/Launchpad/fe_img_four.webp"),
    title: "Pools of Powered Liquidity ",
    description:
      "Our most popular Whitelabel launchpad now has an automatic liquidity option, allowing users to contribute to a money pool and share returns",
  },
  {
    img: require("../../../image/Launchpad/fe_img_five.webp"),
    title: "Staking Module",
    description:
      "The white-label launchpad platform enables managers to build a variety of investor categories for round-ups based on the tokens placed on it",
  },
  {
    img: require("../../../image/Launchpad/fe_img_six.webp"),
    title: "Wallet Integration",
    description:
      "The white-label launchpad we provide allows you to incorporate digital wallets via a feature. Tokens are made available to users through cryptocurrency projects",
  },
  {
    img: require("../../../image/Launchpad/fe_img_seven.webp"),
    title: "KYC Compliance",
    description:
      "Using our KYC compliance solution, the platform owner can accept user identity credentials before providing authorization to use the launchpad platform",
  },
  {
    img: require("../../../image/Launchpad/fe_img_eight.webp"),
    title: "Transparency",
    description:
      "The relationships will be trustworthy if the lottery-based method of acquiring project tokens is totally open and fair",
  },
];

export const whyChooseData = [
  {
    img: require("../../../image/Launchpad/why_img_one.webp"),
    title: "Highly noticeable",
    description:
      "Your incubated efforts can be featured on a Whitelabel launchpad for more visibility, which encourages investors to invest.",
  },
  {
    img: require("../../../image/Launchpad/why_img_two.webp"),
    title: "Community Expansion",
    description:
      "Entrepreneurs can use Launchpad to connect with a large audience of investors and fans, potentially contributing to the project's ecosystem expansion in the near future",
  },
  {
    img: require("../../../image/Launchpad/why_img_three.webp"),
    title: "Trustworthiness",
    description:
      "The launchpad increases the project owner's credibility and influence by revealing all critical data about the owners and their plans",
  },
  {
    img: require("../../../image/Launchpad/why_img_four.webp"),
    title: "Profitability",
    description:
      "Your incubated efforts can be featured on a Whitelabel launchpad for more visibility, which encourages investors to invest",
  },
];

export const processData = [
  {
    id: 1,
    title: "Developing Your Concepts",
    description:
      "We begin by considering your needs for creating the launchpad. We will carefully listen to your requirements, and you can discuss any specs or modification requests with us.",
  },
  {
    id: 2,
    title: "Design and Development",
    description:
      "This is a critical stage in the launchpad development process. Our back-end developers will be in charge of implementing the specifications you specified in the initial stage. And our front-end developers will begin work on the client-side or user interface.",
  },
  {
    id: 3,
    title: "Token Generation",
    description:
      "In general, launchpads will have their own native tokens, which will be purchased by crowdfunding participants. The native tokens purchased will be used to invest in the cryptocurrency project of their choice. We will create native tokens for your launchpad by noting down details such as the token's symbol, name, and initial supply.",
  },
  {
    id: 4,
    title: "Testing and Launching",
    description:
      "Our testing team will perform careful testing to ensure that your launchpad is flawless. Because we have ready-made launchpad development solutions, the launch period will be shorter than if you built your launchpad from the ground up.",
  },
];

export const bestFeatures = [
  {
    img: require("../../../image/Launchpad/bst_img_one.webp"),
    title: "Transparency",
  },
  {
    img: require("../../../image/Launchpad/bst_img_two.webp"),
    title: "Open Source",
  },
  {
    img: require("../../../image/Launchpad/bst_img_three.webp"),
    title: "Customized Service",
  },
  {
    img: require("../../../image/Launchpad/bst_img_four.webp"),
    title: "Feature-Rich Security Offerings",
  },
  {
    img: require("../../../image/Launchpad/bst_img_five.webp"),
    title: "Exceptional Developers",
  },
  {
    img: require("../../../image/Launchpad/bst_img_six.webp"),
    title: "24*7 Support",
  },
];
